import Vue from "vue";
import moment from "moment";

import App from "./App.vue";
import router from "./router";

import "@fortawesome/fontawesome-pro/css/all.css";
import "@/assets/css/tailwind.css";
import "@/assets/css/app.scss";
import "nprogress/nprogress.css";

import * as Sentry from "@sentry/browser";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://9b4d71940a964f25a1a3ad90d6ccb511@sentry.io/1441612",
    integrations: [new Sentry.Integrations.Vue({ Vue })],
    environment: process.env.NODE_ENV,
    release: process.env.VUE_APP_SENTRY_RELEASE
  });
} else {
  // You may remove this once you are sure everything works fine
  console.debug("Not configuring Sentry, environment is", process.env.NODE_ENV);
}

Vue.config.productionTip = false;

Vue.filter("formatDate", function(strFecha, formato, adicional) {
  formato = formato || "DD MMM YYYY";
  return moment(strFecha).format(formato) + (adicional ? adicional : "");
});

Vue.filter("prettyNumber", function(value, style) {
  const formatter = new Intl.NumberFormat("es-CL", {
    style,
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

window.EventBus = new Vue();

moment.locale("es");

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
